var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm.material.coleccion))]),_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm.material.formato))]),_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm.tipoDeMaterial(_vm.material)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }